<div class="row mt-5 justify-content-center">
  <div class="col-lg-12">

    <p class="text-center px-5 mb-5" class="wow bounceInRight" data-wow-duration="2s">
      <span [style.font-size]="'300%'" class="pr-1 text-secondary">
        <i class="fas fa-quote-right"></i>
      </span><br />
      <em class="text-secondary" [style.font-size]="'150%'">
        Our one and only motivation: Cyberserenity for everyone.
      </em>

    </p>


    <div class="wow bounceInLeft" data-wow-duration="2s">
      <app-how-it-works-section [word]="'New'">
      </app-how-it-works-section>
      <p>
        We use the latest technologies to promote a quality service that is ahead of its time.
        Every day, we process a little over a billion events.
        The Big Data, we've been in it for over ten years.
        But then why "New"? Because we are constantly reinventing ourselves, in order to guarantee the best possible
        service to our customers.
        This time, we have completely rethought the core of our business to make it even better and for you to get the
        most out of it.
      </p>
    </div>

    <div class="wow bounceInLeft" data-wow-duration="2s">
      <app-how-it-works-section [word]="'Intelligence'">
      </app-how-it-works-section>
      <p>
        What makes cybersecurity effective is the availability of relevant and up-to-date expertise and information.
        To achieve this, we rely on a team of experts who are first and foremost cybersecurity enthusiasts.
        These skills allow us to take advantage of the large volume of information we have by valuing it through a
        multitude of analysis and classifications.
        Unlike many others, we do not only do artificial intelligence.
        We are proud to say that we are promoting hybrid intelligence.
        We rely on our artificial intelligence engines but also and above all on our common sense and human know-how.
      </p>
    </div>

    <div class="wow bounceInLeft" data-wow-duration="2s">
      <app-how-it-works-section [word]="'Cyber-threat'">
      </app-how-it-works-section>
      <p>Cyber attacks can cause power outages, military equipment failures and breaches of national security secrets.  They can lead to the theft of valuable and sensitive data such as medical records. They can disrupt telephone and computer networks or paralyze systems, making data unavailable. It is no exaggeration to say that cyber threats can affect the way life works as we know it.
        This is why it is important for everyone to protect themselves against it. </p>
    </div>

    <div class="wow bounceInLeft" data-wow-duration="2s">
      <app-how-it-works-section [word]="'Knowledge'">
      </app-how-it-works-section>
      <p>
        Our knowledge of cyber threats is based on the high quality and diversity of brains and information we have in our lab.
The strength of our service is its memory. NICKI remembers everything. Each analysis is repeated at least once a week in order to have the most up-to-date information possible. This also makes it possible to keep a history of assets.
We also produce continuous improvement work so that each analyzer learns from these errors. All this in order to have the most accurate and precise information.</p>
    </div>

    <div class="wow bounceInLeft" data-wow-duration="2s">
      <app-how-it-works-section [word]="'Inter-Connectivity'">
      </app-how-it-works-section>
      <p>

          Our engine has the ability to inter-connect with a wide range of equipment. This makes it possible to offer everyone the opportunity to optimize their cybersecurity in an efficient and unrestricted way. This aspect also offers the possibility of meeting new needs such as multi-cloud or IoT. It is adaptable and malleable.

          Cybersecurity is a daily struggle on many fronts, we promote information sharing for the community.



        Because sharing is caring.

        This is done in different ways, we have contributed to the development of three analyzers for the TheHive project. We operate as CERT and therefore use MISP to exchange information with the network.

Our one and only motivation: the cyberserenity for everyone.</p>
    </div>






  </div>
</div>
